import { Box } from "@mui/material";
import { APILoadingStatus, useApiLoadingStatus } from "@vis.gl/react-google-maps";
import { useEffect } from "react";
import GoogleMapFramePending from "./GoogleMapFramePending";

const MapLoadingCover = () => {
  const status = useApiLoadingStatus();
  const visible = status === APILoadingStatus.NOT_LOADED
    || status === APILoadingStatus.LOADING;

  useEffect(() => {
    if (window.parent === window) return;
    window.parent.postMessage(
      { type: visible ? "mapLoading" : "mapReady" },
      window.location.origin,
    );
  }, [visible]);

  if (!visible) return null;

  return (
    <Box sx={{ position: "absolute", inset: 0, zIndex: 2 }}>
      <GoogleMapFramePending />
    </Box>
  );
};

export default MapLoadingCover;
